import * as React from "react";
import StepWizard from "react-step-wizard";
import { ContactDetails, ContactDetailsFields } from "./contact-details";
import { Schedule, ScheduleFields } from "./schedule";
import { HomeDetails, HomeDetailsFields } from "./home-details";
import { ServicesRequired, ServicesRequiredFields } from "./services-required";
import { AddressDetails, AddressDetailsFields } from "./address-details";
import { AdditionalDetails, AdditionalDetailsFields } from "./additional-details";
import { Review, ReviewFields } from "./review";
import { ThankYou } from "./thank-you";
import * as Helpers from "../helpers";

export type BookingRequestFields
    = ContactDetailsFields
    & ScheduleFields
    & HomeDetailsFields
    & ServicesRequiredFields
    & AddressDetailsFields
    & AdditionalDetailsFields
    & ReviewFields;

export class BookingRequest extends React.Component<WizardProps & WizardPropsAbandonedRestore<BookingRequestFields>, WizardState<BookingRequestFields>> {
    constructor(props: WizardProps & WizardPropsAbandonedRestore<BookingRequestFields>) {
        super(props);

        const initial_state : WizardState<BookingRequestFields>  = {
            form_values: {
                schedule_time_required: "2",

                home_bedrooms: "1",
                home_bathrooms: "1"
            },
            required: {
                contact_first_name: true,
                contact_last_name: true,
                contact_phone: true,
                contact_email: [ "required", "email" ],

                schedule_frequency: true,
                schedule_frequency_other: true,
                schedule_time_required: true,
                schedule_cleaner_day: true,
                schedule_cleaner_backup: true,
                schedule_cleaner_time: true,

                home_bedrooms: true,
                home_bathrooms: true,
                home_pets: true,
                home_pets_details: false,

                services_required: true,
                services_required_other: true,

                address_line_1: true,
                address_line_2: false,
                address_town: true,
                address_county: true,
                address_postcode: true,

                address_source: true,
                address_source_other: true,
                address_voucher: false,

                review_marketing_consent: false,
                review_gdpr_consent: [ "boolean_required" ]
            },
            success: false,
            abandoned_id: props.abandoned_data?.abandoned_id ?? null
        }

        if (props.abandoned_data) {
            const form_data : Partial<BookingRequestFields & AbandonedFormFields & AbandonedUpdateFields> = {};
            Object.assign(form_data, props.abandoned_data);

            // Clean up any unwanted additional properties
            delete form_data.abandoned_id;
            delete form_data.franchise_id;

            Object.assign(initial_state.form_values, form_data);
        }

        this.state = initial_state;
    }

    async step_change_update_abandoned()
    {
        if (this.state.success) {
            return;
        }

        const target = this.state.abandoned_id && this.state.abandoned_id !== ""
            ? `/uk/App_Services/BookingRequestService.asmx/UpdateAbandonedFormEntryReact`
            : `/uk/App_Services/BookingRequestService.asmx/CreateAbandonedFormEntryReact`;

        const abandoned_fields: AbandonedFormFields & AbandonedUpdateFields  = {
            franchise_id: this.props.franchise_id ? this.props.franchise_id : null,
            abandoned_id: this.state.abandoned_id
        };
        const form_data = Object.assign(abandoned_fields, this.state.form_values);
        const response = await fetch(target, {
            method: 'POST',
            body: JSON.stringify(form_data),
            headers: [
                ["Content-Type", "application/json; charset=UTF-8"],
                ["Accept", "application/json"]
            ]
        });

        const abandoned_id = (await response.json() as { d: string }).d;
        this.setState(() => {
            return { abandoned_id: abandoned_id };
        });
    }

    render() {
        return (
            <React.StrictMode>
                <StepWizard onStepChange={() => this.step_change_update_abandoned()} className="text-left">
                    <ContactDetails
                        franchise_details={this.props.contact_details}
                        form_values={this.state.form_values}
                        required={this.state.required}
                        update_value={(name, value) => Helpers.UpdateValue(this, name, value)}
                        update_success={(success) => Helpers.UpdateSuccess(this, success)}
                    />
                    <Schedule
                        franchise_details={this.props.contact_details}
                        form_values={this.state.form_values}
                        required={this.state.required}
                        update_value={(name, value) => Helpers.UpdateValue(this, name, value)}
                        update_success={(success) => Helpers.UpdateSuccess(this, success)}
                    />
                    <HomeDetails
                        franchise_details={this.props.contact_details}
                        form_values={this.state.form_values}
                        required={this.state.required}
                        update_value={(name, value) => Helpers.UpdateValue(this, name, value)}
                        update_success={(success) => Helpers.UpdateSuccess(this, success)}
                    />
                    <ServicesRequired
                        franchise_details={this.props.contact_details}
                        form_values={this.state.form_values}
                        required={this.state.required}
                        update_value={(name, value) => Helpers.UpdateValue(this, name, value)}
                        update_success={(success) => Helpers.UpdateSuccess(this, success)}
                    />
                    <AddressDetails
                        franchise_details={this.props.contact_details}
                        form_values={this.state.form_values}
                        required={this.state.required}
                        update_value={(name, value) => Helpers.UpdateValue(this, name, value)}
                        update_success={(success) => Helpers.UpdateSuccess(this, success)}
                    />
                    <AdditionalDetails
                        franchise_details={this.props.contact_details}
                        form_values={this.state.form_values}
                        required={this.state.required}
                        update_value={(name, value) => Helpers.UpdateValue(this, name, value)}
                        update_success={(success) => Helpers.UpdateSuccess(this, success)}
                    />
                    <Review
                        franchise_details={this.props.contact_details}
                        form_values={this.state.form_values}
                        required={this.state.required}
                        update_value={(name, value) => Helpers.UpdateValue(this, name, value)}
                        update_success={(success) => Helpers.UpdateSuccess(this, success)}
                    />
                    <ThankYou
                        franchise_details={this.props.contact_details}
                        success={this.state.success}
                    />
                </StepWizard>
            </React.StrictMode>
        );
    }
}